var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FA2714",
    d: "m10.598 19.713l.149-.03c-.068-2.682-.33-5.374.39-7.988c-.124-.103-.182-.175-.258-.209c-.39-.171-.782-.346-1.184-.495c-.706-.26-.978-.71-.851-1.515c.155.071.295.141.44.2c.476.197.944.418 1.434.576c.65.21.777.37.675 1.029c-.068.449-.156.896-.192 1.347c-.033.413.377.977.707 1.043c.286.06.727-.292.867-.74c.056-.18.03-.39.01-.584c-.046-.451-.121-.898-.167-1.349c-.04-.385.173-.588.55-.714c.53-.178 1.044-.402 1.564-.608c.142-.056.282-.12.441-.187c.074.909-.17 1.251-.981 1.537c-.438.155-.857.362-1.341.57c.723 2.717.449 5.416.49 8.118c.21-.227.357-.466.487-.712c.112-.216.202-.441.307-.66c.497-1.044 1.014-2.08 1.48-3.136a2.8 2.8 0 0 0 .228-1.073c.02-1.77.015-3.542 0-5.314c-.004-.422-.026-.866-.161-1.26c-.241-.707-.458-1.466-.904-2.052c-.802-1.054-2.028-1.343-3.35-1.178c-1.055.13-1.989.585-2.467 1.498c-.503.958-.822 2.003-.815 3.107c.013 1.743-.013 3.486 0 5.229c.002.279.045.579.16.828c.662 1.453 1.35 2.896 2.036 4.34c.064.136.17.256.256.382"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparta);
export default __webpack_public_path__ + "static/media/sparta.2b19f22a295227e863fa179f8ffba3ab.svg";
export { ForwardRef as ReactComponent };